import React, {useState, useContext} from "react";
import {useAuth} from "../../contexts/AuthContext";
import StyleContext from "../../contexts/StyleContext";
import {login as apiLogin, register as apiRegister} from "../../services/api";

const AuthModal = ({onClose, onSuccess}) => {
  const {login} = useAuth();
  const {isDark} = useContext(StyleContext);
  const [tab, setTab] = useState("login");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [notice, setNotice] = useState("");

  const submit = async e => {
    e.preventDefault();
    setErr("");
    setNotice("");
    setBusy(true);
    try {
      const res = tab === "login"
        ? await apiLogin(username.trim(), password)
        : await apiRegister(username.trim(), email.trim(), password);

      if (!res || !res.token || !res.user) {
        throw new Error(res?.error || "Unexpected response");
      }
      login(res.user, res.token);
      if (res.reset) setNotice("Password reset — you're signed in with the new one.");
      if (onSuccess) onSuccess(res.user);
      onClose();
    } catch (e2) {
      setErr(e2.message || "Authentication failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`modal-backdrop ${isDark ? "dark" : ""}`} onClick={onClose}>
      <div className={`modal ${isDark ? "dark" : ""}`} onClick={e => e.stopPropagation()}>
        <h3 className="modal__title">
          {tab === "login" ? "Welcome back" : "Create an account"}
        </h3>
        <p className="modal__subtitle">
          {tab === "login"
            ? "Sign in with your username or email."
            : "Forgot your password? Just re-register with the same email — it'll reset for you."}
        </p>
        <div className="modal__tabs">
          <button
            type="button"
            className={tab === "login" ? "active" : ""}
            onClick={() => { setTab("login"); setErr(""); }}
          >Login</button>
          <button
            type="button"
            className={tab === "register" ? "active" : ""}
            onClick={() => { setTab("register"); setErr(""); }}
          >Register</button>
        </div>

        <form className={`rdf-form ${isDark ? "rdf-dark" : ""}`} onSubmit={submit} noValidate>
          <div className="rdf-group">
            <label className="rdf-label" htmlFor="am-user">
              {tab === "login" ? "Username or email" : "Username"}
            </label>
            <input
              id="am-user"
              type="text"
              className="rdf-input"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
              required
              minLength={3}
              placeholder={tab === "login" ? "you@example.com or rashid" : "rashid"}
            />
          </div>

          {tab === "register" && (
            <div className="rdf-group">
              <label className="rdf-label" htmlFor="am-email">Email</label>
              <input
                id="am-email"
                type="email"
                className="rdf-input"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                placeholder="you@example.com"
              />
            </div>
          )}

          <div className="rdf-group">
            <label className="rdf-label" htmlFor="am-pass">Password</label>
            <input
              id="am-pass"
              type="password"
              className="rdf-input"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              minLength={6}
              placeholder="At least 6 characters"
            />
          </div>

          {err    && <p className="rdf-banner-error">{err}</p>}
          {notice && <p className="rdf-hint" style={{color: "#137333"}}>{notice}</p>}

          <div className="modal__actions">
            <button type="button" className="rdf-button rdf-button--ghost" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="rdf-button" disabled={busy}>
              {busy ? "Please wait…" : tab === "login" ? "Sign in" : "Create account"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AuthModal;
